export default {
  titulo: 'Legislación específica para aeródromos y objetos proyectados en el espacio aéreo',
};
